<template lang="pug">
    .col-span-6
        label.block.text-sm.font-medium.text-gray-700(
            :for="'field_' + parameter.id"
            :class="{ 'required': parameter['required'] }")
            | {{ parameter.name }}
        select(class='focus:outline-none focus:ring-indigo-500'
        +' focus:border-indigo-500 sm:text-sm'
        +' mt-1 block w-full py-2 px-3 border'
        +' border-gray-300 bg-white rounded-md shadow-sm'
            autocomplete='off'
            v-model='selected'
            :id="'field_' + parameter.id"
            @change='handleChange'
            :class="{ 'form-error': error }")
            option(value='false')
                | Выберите значение
            option(v-for='option in options' :value='option.id')
                | {{ option.name }}
        p.mt-2.p-1.rounded.text-sm.text-red-500.bg-gray-100(v-if='error')
            | {{ error.message || 'Поле обязательно для заполнения' }}
</template>

<script>

export default {
    name: 'ItemFormGroupParameterSelectbox',

    props: {
        parameter: {
            type: Object,
        },

        value: {
            type: [String, Number],
        },

        error: {
            type: [Object, Boolean],
        },
    },

    data () {
        return {
            options: {},
            selected: this.value || false,
            isExtraFirst: true,
        }
    },

    computed: {
        extra() {
            return this.parameter.hasOwnProperty('extra_serialized') ? this.parameter.extra_serialized : false
        }
    },

    watch: {
        extra: {
            handler(newExtra) {
                if (newExtra) {
                    this.options = newExtra
                    if (!this.isExtraFirst) {
                        this.$emit('input', 'false')
                    }
                    this.isExtraFirst = false
                }
            },
        },

        value: {
            handler(newValue) {
                if (newValue) {
                    this.selected = this.value
                }
            },
        },
    },

    mounted() {
        if (this.extra) {
            // this.options = (typeof this.extra === "string") ? JSON.parse(this.extra) : this.extra
            this.options = this.extra
        }
    },

    methods: {
        handleChange($event) {
            if ($event.target.value) {
                this.$emit('input', $event.target.value)
            }
        },
    },

}
</script>
